export interface Theme {
    backgroundColor: string;
    cardBackground: string;
    primaryText: string;
    secondaryText: string;
    accent: string;
    borderRadius: string;
}

export function getDefaultTheme(): Theme {
    return {
        backgroundColor: '#f5f7fa',
        cardBackground: '#ffffff',
        primaryText: '#1f2933',
        secondaryText: '#52616b',
        accent: '#3577c0',
        borderRadius: '16px',
    };
}

export const headingFontStack = "'PT Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";
export const bodyFontStack = "Montserrat, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";
export const brandFontStack = bodyFontStack; // Default to body font for backwards compatibility

